import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=354ca5aa&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&id=354ca5aa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ca5aa",
  null
  
)

export default component.exports